// import { Virtual } from "swiper";
import "./App.css";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header";
import Hero from "./Components/Hero";
import Products from "./Components/Products/Products";
import Slider from "./Components/Slider/Slider";
import Testimotail from "./Components/Testimotails/Testimotail";
import Virtual from "./Components/Virtuals/Virtual";

function App() {
  return (
    <div className="App">
      <Header/>
      <Hero/>
      <Slider/>
      <Virtual/>
      <Products/>
      <Testimotail/>
      <Footer/>
    </div>
  );
}

export default App;
